module.exports = __webpack_public_path__ + "img/banner_quad.74b51b7a.webp";